import { courses } from "../constants/common";

export const getCourseLabel = (id, lang = "en") => {
  const course = courses.find((c) => c.id === id);
  if (!course) return "";
  return lang === "ar" ? course.name_ar : course.name_en;
};
